export default __webpack_public_path__ + "dca5f31519d0e4315a51c942f18b85d3.svg";